class PostsPublished extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, data, listRow) {
    super(app, container, listRow, false);
    this.data = data;
    this.container.empty();
  }

  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "postsPublished": this.staticPH,
      }, 1);

      const result = this.data;

      this.isRendering = false;

      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);


      result.postsPublished.postsPublished = Utils.convertToUsNumberSystem(result.postsPublished.postsPublished );
      const $metrics = $(page(result.postsPublished));

      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts (result) {
    const postsPublishedByProviders = result.postsPublishedByProviders;

    // Build a map from provider name to its count
    var providerMap = {};
    postsPublishedByProviders.series.forEach(function(item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('posts-published-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'top',
        formatter: function (name) {
          var value = providerMap[name] || 0;
          return name + ' (' + value + ')';
        }
      },
      series: [
        {
          name: 'Posts Published To',
          type: 'pie',
          radius: [20, 80],
          center: ['65%', '50%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 8
          },
          data: postsPublishedByProviders.series
        }
      ]
    };

    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }
}

class SocialImpressions extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, data, listRow) {
    super(app, container, listRow, false);
    this.data = data;
    this.container.empty();
  }
  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "postsImpressions": this.staticPH,
      }, 1);


      const result = this.data;

      this.isRendering = false;

      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);

      result.postsImpressions.postsImpressions = Utils.convertToUsNumberSystem(result.postsImpressions.postsImpressions );
      const $metrics = $(page(result.postsImpressions));
      console.log(this.container, $metrics);
      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts (result) {
    const postsImpressionsByProviders = result.postsImpressionsByProviders;

    // Build a map from provider name to its count
    var providerMap = {};
    postsImpressionsByProviders.series.forEach(function(item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('social-impressions-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      grid: {left: 0, right: 0, top: 0, bottom: 0, containLabel: true},
      textStyle: {
        fontFamily: 'Poppins,sans-serif',
      },
      tooltip: {
        trigger: 'item',
        formatter: '<b>{a}</b> <br/>{b}: {c} <b>({d}%)</b>'
      },
      legend: {
        show:false,
        orient: 'horizontal',
        left: 'left',
        bottom: 'bottom',
      },
      series: [
        {
          name: 'Sent to',
          type: 'pie',
          // Center the pie chart
          center: ['50%', '50%'],
          // Adjust the radius so the pie fills the container as much as possible
          radius: ['0%', '60%'],
          data: postsImpressionsByProviders.series,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };


    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }
}

class SocialEngagements extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, data, listRow) {
    super(app, container, listRow, false);
    this.data = data;
    this.container.empty();
  }

  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "postEngagements": this.staticPH,
      }, 1);

      const result = this.data;
      this.isRendering = false;


      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);

      result.postEngagements.postEngagements = Utils.convertToUsNumberSystem(result.postEngagements.postEngagements );
      const $metrics = $(page(result.postEngagements));
      console.log(this.container, $metrics);
      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts (result) {
    const postEngagementsByProviders = result.postEngagementsByProviders;

    var dom = document.getElementById('social-engagements-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          return `${params.name}: ${params.value}`;
        }
      },
      grid: {left: '2%', right: 5, top: 25, bottom: 0, containLabel:true},
      textStyle: {
        fontFamily: 'Poppins,sans-serif',
      },
      xAxis: {
        data: ['Comments', 'Likes', 'Shares'],
        axisLabel: {
          interval: 0, // Show all labels
          rotate: 0, // Prevent rotation (adjust if needed)
          show: true, // Ensure visibility
          formatter: function (value) {
            return value; // Ensure full text display
          }
        }
      },

      yAxis: {},
      dataGroupId: '',
      animationDurationUpdate: 500,
      series: {
        type: 'bar',
        id: 'socialEngagement',
        data: postEngagementsByProviders.summary,
        universalTransition: {
          enabled: true,
          divideShape: 'clone'
        }
      }
    };
    const drilldownData = postEngagementsByProviders.drilldown;

    myChart.on('click', function (event) {
      if (event.data) {
        var subData = drilldownData.find(function (data) {
          return data.dataGroupId === event.data.groupId;
        });
        if (!subData) {
          return;
        }
        myChart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return `${params.name}: ${params.value}`;
            }
          },
          textStyle: {
            fontFamily: 'Poppins,sans-serif',
          },
          xAxis: {
            data: subData.data.map(function (item) {
              return item[0];
            })
          },
          series: {
            type: 'bar',
            id: 'socialEngagement',
            dataGroupId: subData.dataGroupId,
            data: subData.data.map(function (item) {
              return item[1];
            }),
            universalTransition: {
              enabled: true,
              divideShape: 'clone'
            }
          },
          graphic: [
            {
              type: 'text',
              right: 5,
              top: 0,
              style: {
                text: '← Back',
                fontSize: 14,
                fontWeight: 'bold',
                cursor: 'pointer'
              },
              onclick: function () {
                myChart.setOption({
                  ...option,
                  graphic: [] // Ensure back button is removed
                }, true); // Force update
              }
            }
          ]
        });
      }
    });

    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }
}